export default "__VITE_ASSET__740f577f__"